import {Component, Inject, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
    AuditItem,
    IPortfolioResultResponse
} from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';
import {IrbEditorPortfolioResultService} from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.service';
import {catchError, map, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {UtilityService} from '@irb-common/services/utility.service';
import {AuthService} from '@irb-common/services/auth.service';
import {IRebalResponseObject} from '@irb/irb-rebalance/results/results.model';
import {IrbModelsEvents} from '@irb/irb-models/irb-models.events';
import {AppService} from '@irb/app.service';
import {IrbAgGridExportService} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';
import { DeleteSecuritySoftDialogGridLayoutService } from './delete-security-soft-dialog.grid-layout.service';

interface ISecurityUsageData {
  relatedAs: string;
  relatedToDesc: string;
  relatedToName: string;
  securitySymb: string;
}

@Component({ standalone: false,
  selector: 'irb-delete-securities-soft-dialog',
  templateUrl: './delete-securities-soft-dialog.component.html',
  styleUrls: ['./delete-securities-soft-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DeleteSecuritiesSoftDialogComponent implements OnInit {
    isLoading: boolean;
    totalAffected: number;
    private affectedPortfolios: number;
    private exportPayload: string = '';
    private strGridData: string = '';
    private exportFileName = 'DeleteSecurity';
    grid: any;
    gridOptions: any;
    tempDataList: any[] = [];
    modelList: any[] = [];
    columnHeaders = ['Security', 'Will no longer be', 'For this other security/portfolio/account/model'];
    frameworkComponents: any;

    constructor(
        public dialogRef: MatDialogRef<DeleteSecuritiesSoftDialogComponent>,
        private portfolioService: IrbEditorPortfolioResultService,
        private utilityService: UtilityService,
        private authService: AuthService,
        public as: AppService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public ges: IrbAgGridExportService,
        private gls: DeleteSecuritySoftDialogGridLayoutService
    ) {
      this.gridOptions = {
        columnDefs: this.gls.getColumnDefs(),        
        floatingFilter: false,
        overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
        context: { componentParent: this }
      };
      
      this.frameworkComponents = this.gls.getFrameworkComponents();
    }

  ngOnInit(): void {
    this.tempDataList = this.data.response as Array<ISecurityUsageData>;
    this.totalAffected = this.data.affectedsecuritiescount + this.data.affectedportfoliocount;
    this.getGridData();
  }

  getGridData() {
    this.tempDataList.forEach((item: ISecurityUsageData) => {
      if(item.relatedToDesc.includes('in Security Model-'))
      {
        const modelSplits = item.relatedToDesc.split("-");
        item.relatedToName = modelSplits[1];
      }
      this.strGridData += item.securitySymb + ',' + item.relatedAs + ',' + item.relatedToName + '\n';
    
    });
  }
   


  continue() {
    this.as.fireEvent(IrbModelsEvents.SHOW_DELETE_SECURITIES_DIALOG, this.data);
    this.close();
  }

  export() {
    this.exportPayload += this.columnHeaders[0] + ',' + this.columnHeaders[1] + ',' + this.columnHeaders[2] + '\n';
    this.exportPayload += this.strGridData;
    this.ges.setPrefix(this.exportFileName, "csv");
    const blob = new Blob([this.exportPayload]);
    this.ges.download(blob);
  }


  close() {
    if (this.dialogRef.close != undefined)
      this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
    //this.grid.api.sizeColumnsToFit();
  }
}
